export default __webpack_public_path__ + "static/media/st-andrews-bangkok.ebcae7f2.png";